//get All books form server
export const GET_BOOKS_LOADING = "books/loading";
export const GET_BOOKS_SUCCESS = "books/success";
export const GET_BOOKS_ERROR = "books/error";

//get All books form server
export const GET_BOOK_DETAILS_LOADING = "book/detail/loading";
export const GET_BOOK_DETAILS_SUCCESS = "book/detail/success";
export const GET_BOOK_DETAILS_ERROR = "book/detail/error";

//get All books form server
export const GET_SEARCH_BOOKS_LOADING = "seaarch/books/loading";
export const GET_SEARCH_BOOKS_SUCCESS = "seaarch/books/success";
export const GET_SEARCH_BOOKS_ERROR = "seaarch/books/error";

// Filter buy Category
export const GET_FILTER_BOOKS_LOADING = "filter/books/loading";
export const GET_FILTER_BOOKS_SUCCESS = "filter/books/success";
export const GET_FILTER_BOOKS_ERROR = "filter/books/error";
